import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const notificationHistoryUrl = `${SERVER_API}/notification/history`;

export default {
  GET: {
    method: 'GET',
    url: `${notificationHistoryUrl}`,
  } as IEndpointData,
  RESEND(notificationId: string, messageId: string): IEndpointData {
    return {
      method: 'POST',
      url: `${SERVER_API}/notification/${notificationId}/messages/${messageId}/resend`,
    };
  },
};
